export interface RespuestaBlob {
  contenido: Blob;
  nombre?: string;
  extension?: string;
  fecha: string;
}

export const convertBase64ToBlob = (base64Str: string, type: string): Blob => {
    // Decode Base64 string
    const decodedData = window.atob(base64Str);

    // Create UNIT8ARRAY of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length);

    // Insert all character code into uInt8Array
    for (let i = 0; i < decodedData.length; ++i) {
        uInt8Array[i] = decodedData.charCodeAt(i);
    }

    // Return BLOB image after conversion
    return new Blob([uInt8Array], { type: type });
}